/* eslint-disable @typescript-eslint/no-explicit-any */
export interface BaseAPIErrorModel {
  type?: string | null | undefined;
  title?: string | null | undefined;
  status?: number | null | undefined;
  traceId?: string | null | undefined;
  errors?: any | null | undefined;

  getAllErrorMessages(): string[];
}

export class BaseAPIErrorModel implements BaseAPIErrorModel {
  type?: string | null | undefined;
  title?: string | null | undefined;
  status?: number | null | undefined;
  traceId?: string | null | undefined;
  errors?: any | null | undefined;

  constructor(error: BaseAPIErrorModel) {
    this.type = error?.type;
    this.title = error?.title;
    this.status = error?.status;
    this.traceId = error?.traceId;
    this.errors = error?.errors;
  }

  public getAllErrorMessages(): string[] {
    const errorMessages: string[] = [];

    if (typeof this.errors !== 'undefined') {
      if (Array.isArray(this.errors)) {
        for (let i = 0; i !== this.errors.length; i++) {
          errorMessages.push(this.errors[i]);
        }
      } else if (typeof this.errors === 'object') {
        if ((this.errors?.length ?? 0) != 0) {
          for (const k in this.errors) {
            for (let i = 0; i !== this.errors[k].length; i++) {
              errorMessages.push(this.errors[k][i]);
            }
          }
        }

        if ((this.errors?.errors?.length ?? 0) != 0) {
          const serverErrors = this.errors?.errors as any[];

          for (let i = 0; i !== serverErrors.length; i++) {
            if (serverErrors[i].errorMessage) {
              errorMessages.push(serverErrors[i].errorMessage);
            }
          }
        }
      }
    } else {
      if (!errorMessages.includes('Oops..')) {
        errorMessages.push('Oops.. Something Went Wrong..');
      }
    }

    return errorMessages;
  }
}
